import React from 'react';
import './chapters.scss';

function Chapter5() {
  return (
    <div className="chapters__chapter">
      <h3>Breaking the Cycle</h3>
      <p className="chapters__chapter__paragraph">
        Grace and Ben lived through similar cycles of hope and disappointment: hope, as they tried a
        long list of different treatments under the guidance of their care team, and disappointment,
        as they continued to experience the familiar symptoms of clinical depression. But even as
        they were challenged, they kept looking for a way forward.
      </p>
      <p className="chapters__chapter__paragraph">
        Amid the worst depression she’d ever experienced, Grace came to a resolution. She was going
        to try every possible treatment for her depression, from oral antidepressants and
        interventional treatments to herbal medicines. “I ended up at electroconvulsive therapy.
        That felt like the final arrow in my quiver,” she says. “And the worst part about it was
        that it didn’t work. I started to think that there had to be something wrong with me.”
      </p>
      <p className="chapters__chapter__paragraph">
        A talk with her therapist bolstered her resolve. As Grace remembers, “She asked me, ‘If you
        had diabetes and you needed to take insulin to get better, would you not do it?” That was
        the beginning of a new phase for Grace. She was diagnosed with TRD, and it started her “down
        a rabbit hole of research.”
      </p>
      <p className="chapters__chapter__paragraph">
        After a major depressive episode sent Ben to rock bottom, his family convinced him to move
        across the country and live with his sister. “My sister saw first-hand the severity of the
        depression I was experiencing and that my medications weren’t helping,” he says. With her
        help, the support of his brother and nephew, and the guidance of his therapist and
        psychiatrist, he was diagnosed with TRD and began to learn about treatment options
        available.
      </p>
    </div>
  );
}

export default Chapter5;
